<template>
    <v-container>
        <div v-if="showcargando == true" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row>
            <v-card width="100%" class="mx-1">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-card flat class="text-xs-center ma-3" v-if="valtipoUsr == 1">
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Alta Usuario Interno</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span>Tipo de Usuario: </span>
                                <v-select dense outlined placeholder="Seleccione tipo de usuario" :items="tipoUsr"
                                    item-text="label" item-value="tipo" v-model="alta.tipoUsr"
                                    :disabled="disabledtipousr" :filled="disabledtipousr">
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8" style="display: grid; place-items: center;">
                                <span style="font-weight: bold; font-size: x-large; text-align: center;"
                                    class="ml-1">Tipo de Perfil</span>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Perfil</span>
                                <v-select dense outlined placeholder="Seleccione un Perfil" :items="perfiles"
                                    item-text="pfdesc" item-value="pfclave" v-model="alta.perfil" :error="errorPerfil"
                                    :error-messages="msgerrorPerfil"></v-select>
                            </v-col>
                        </v-row>
                        <!-- Supervisor Operativo  y Gerente -->
                        <v-row class="mt-4" justify="center" v-if="showGerencia">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Gerencia</span>
                                <v-select dense outlined placeholder="Seleccione tipo de Gerencia" :items="gerencias"
                                    item-text="Nombre" item-value="Clave" v-model="alta.gerencia" :error="errorGerencia"
                                    :error-messages="msgerrorGerencia"></v-select>
                            </v-col>
                        </v-row>
                        <!-- Supervisor Operativo -->
                        <v-row class="mt-4" justify="center" v-if="showSupervisorias">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Supervisorias</span>
                                <v-select dense outlined placeholder="Seleccione tipo de Supervisoria"
                                    :items="supervisorias" item-text="Nombre" item-value="Clave"
                                    v-model="alta.supervisoria" :disabled="disableSupervisorias"
                                    :filled="disableSupervisorias" :error="errorSupervisorias"
                                    :error-messages="msgerrorSupervisorias"></v-select>
                            </v-col>
                        </v-row>
                        <!-- Ejecutivo y Ejecutivo Dictamen -->
                        <v-row class="mt-4" justify="center" v-if="showtipoEjec">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Tipo de ejecutivo</span>
                                <v-select dense outlined placeholder="Seleccione tipo de Ejecutivo"
                                    :items="tiposEjecutivo" item-text="Nombre" item-value="Clave"
                                    v-model="alta.tipoEjec" :error="errorTEjecutivo"
                                    :error-messages="msgerrorTEjecutivo"></v-select>
                            </v-col>
                        </v-row>
                        <!-- Ejecutivo y Ejecutivo Dictamen -->
                        <v-row class="mt-4" justify="center" v-if="showCuentas">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Cuentas</span>
                                <v-autocomplete v-model="alta.cliente" chips multiple clearable deletable-chips
                                    :error="errorClienteI" :error-messages="msgerrorClienteI" :items="clientes" outlined
                                    dense item-text="Nombre" item-value="Clave">
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <!-- Abogado -->
                        <v-row class="mt-4" justify="center" v-if="showprclave">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Clave Abogado (PRCLAVE)</span>
                                <multiselect v-model="alta.prclave" @input="validaProveedor = false" id="ajax"
                                    label="Nombre" track-by="prclave" open-direction="bottom" :options="abogados"
                                    :searchable="true" :options-limit="30" :limit="3" :allow-empty="false"
                                    :internal-search="false" deselect-label="No se puede remover el valor seleccionado"
                                    select-label="Seleccione una opción" @search-change="BuscarAbogados"
                                    placeholder="Seleccione una opción" @select="errorPrclave = false">
                                    <template slot="clear" slot-scope="props">
                                        <div class="multiselect__clear" v-if="alta.prclave"
                                            @mousedown.prevent.stop="limpiarProveedor(props.search)"></div>
                                    </template>
                                    <span slot="noResult">No hay resultados.</span>
                                </multiselect>
                                <div v-if="errorPrclave">
                                    <span class='spanError' style="color:red;font-size:12px">
                                        {{ msgerrorPrclave }}
                                    </span>
                                    <br />
                                </div>
                            </v-col>
                        </v-row>
                        <v-row class="mt-1" justify="center">
                            <v-col cols="12" md="8">
                                <v-checkbox label="Insertar permisos predefinidos del perfil seleccionado"
                                    v-model="alta.valpermisosdef"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8" style="display: grid; place-items: center;">
                                <span style="font-weight: bold; font-size: x-large; text-align: center;"
                                    class="ml-1">Área</span>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Área</span>
                                <v-select dense outlined placeholder="Seleccione un Área" :items="areas"
                                    item-text="pudireccion" item-value="pudireccion" v-model="alta.area"
                                    :error="errorArea" :error-messages="msgerrorArea"></v-select>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Puesto</span>
                                <v-select dense outlined placeholder="Seleccione un Puesto" :items="puestos"
                                    item-text="DescripcionPuesto" item-value="puid" :disabled="disabledPuesto"
                                    :filled="disabledPuesto" :error="errorPuesto" v-model="alta.puesto"
                                    :error-messages="msgerrorPuesto"></v-select>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Jefe directo</span>
                                <v-autocomplete v-model="alta.jefe" :disabled="disabledJefe"
                                    placeholder="Seleccione un Jefe directo" item-text="usnom" item-value="usid"
                                    :items="jefesArea" :filled="disabledJefe" :error="errorJefe"
                                    :error-messages="msgerrorJefe" dense outlined>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Esquema</span>
                                <div class="text-center">
                                    <v-radio-group v-model="alta.esquema" row :error="errorRadio"
                                        :error-messages="msgerrorRadio">
                                        <v-radio label="Nomina" value="N"></v-radio>
                                        <v-radio label="Honorarios" value="H"></v-radio>
                                    </v-radio-group>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8" style="display: grid; place-items: center;">
                                <span style="font-weight: bold; font-size: x-large; text-align: center;"
                                    class="ml-1">Datos del Usuario</span>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center" v-if="this.reactivacion">
                            <v-col cols="12" md="8" style="display: grid; place-items: center;">
                                <span class="ml-1" style="font-weight: bold; font-size: large; color: #FF5C93;">Nota
                                    importante: El usuario es
                                    un reingreso</span>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Nombre(s)</span>
                                <v-text-field ref="nombreField" outlined dense v-model="alta.nombre"
                                    class="text-uppercase" v-on:blur="GenerarLogin()" :error="errorNombre"
                                    :error-messages="msgerrorNombre" @keypress="validarRegex($event, 'LE');"
                                    maxlength="20" @input="updateCampo('nombre', $event)">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Apellido Paterno</span>
                                <v-text-field ref="apellidoPField" v-model="alta.apellidoP" outlined dense
                                    v-on:blur="GenerarLogin()" :error="errorApellidoP"
                                    :error-messages="msgerrorApellidoP" @keypress="validarRegex($event, 'LEA')"
                                    maxlength="20" @input="updateCampo('apellidoP', $event)"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Apellido Materno</span>
                                <v-text-field ref="apellidoMField" v-model="alta.apellidoM" outlined dense
                                    v-on:blur="GenerarLogin()" :error="errorApellidoM"
                                    :error-messages="msgerrorApellidoM" @keypress="validarRegex($event, 'LEA')"
                                    maxlength="20" @input="updateCampo('apellidoM', $event)"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Fecha de nacimiento</span>
                                <v-dialog ref="dialog" outlined v-model="modal" :return-value.sync="alta.fechaNac"
                                    persistent width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div class="date-align-center">
                                            <v-text-field v-model="alta.fechaNac" label="" readonly outlined dense
                                                v-bind="attrs" v-on="on" ref="alta.fechaNac" :error="errorfechaNac"
                                                :error-messages="msgerrorfechaNac"></v-text-field>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="alta.fechaNac" locale="es-mx" scrollable
                                        :show-current="dateCurrent" :max="startdate">
                                        <v-spacer></v-spacer>
                                        <v-btn text color="secondary" @click="modal = false">
                                            Cancelar
                                        </v-btn>
                                        <v-btn text color="primary" @click="$refs.dialog.save(alta.fechaNac)">
                                            Aceptar
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">RFC</span>
                                <v-text-field ref="rfcField" outlined dense v-model="alta.rfc" :error="errorRFC"
                                    :error-messages="msgerrorRFC" @keypress="validarRegex($event, 'NL')"
                                    @keyup.delete="validarRFC(alta.rfc)" v-on:blur="alta.rfc = alta.rfc.toUpperCase()"
                                    maxlength="10" @input="updateCampo('rfc', $event)"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Estado</span>
                                <multiselect v-model="alta.estado"
                                    deselect-label="No se puede remover el valor seleccionado"
                                    selected-label="Seleccionado" select-label="Seleccione una opción" track-by="Clave"
                                    label="Nombre" placeholder="Seleccione una opción" :options="estados"
                                    :allow-empty="false" dense class="multiselectEstados" @select="ObtenerLocalidad">
                                </multiselect>
                                <span v-if="validEstado" class='spanError' style='color:red;font-size:11px'>Campo
                                    requerido</span>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Localidad</span>
                                <multiselect v-model="alta.localidad"
                                    deselect-label="No se puede remover el valor seleccionado"
                                    selected-label="Seleccionado" select-label="Seleccione una opción" track-by="Clave"
                                    label="Nombre" placeholder="Seleccione una opción" :options="localidades"
                                    :allow-empty="false" dense class="multiselectLocalidades" :disabled="dislocalidad"
                                    @select="validLocalidad = false">
                                </multiselect>
                                <span v-if="validLocalidad" class='spanError' style='color:red;font-size:11px'>Campo
                                    requerido</span>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center" v-if="pauobs != ''">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Observaciones: </span>
                                <br />
                                <span class="ml-1" style="font-size: large; font-weight: bold;">{{ pauobs }} </span>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8" style="display: grid; place-items: center;">
                                <span style="font-weight: bold; font-size: x-large; text-align: center;"
                                    class="ml-1">Login del Usuario</span>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Login</span>
                                <multiselect v-model="alta.login" @input="validaProveedor = false" id="ajax"
                                    open-direction="bottom" :options="logins" :searchable="true" :options-limit="30"
                                    :taggable="true" deselect-label="No se puede remover el valor seleccionado"
                                    placeholder="Seleccione una opción" :disabled="disabledLogin" @tag="addLogin"
                                    tag-position="bottom" tag-placeholder="Agregar como nueva etiqueta"
                                    @select="errorLogin = false" selectLabel="Seleccionar" selected-label="Seleccionado"
                                    :allow-empty="false">
                                    <template slot="clear" slot-scope="props">
                                        <div class="multiselect__clear" v-if="alta.login"
                                            @mousedown.prevent.stop="limpiarLogin(props.search)"></div>
                                    </template>
                                    <span slot="noResult">No hay resultados.</span>
                                </multiselect>
                                <span v-if="errorLogin" class='spanError' style='color:red;font-size:11px'>{{
                                    msgerrorLogin }}</span>
                                <span v-if="shownota" class='spanError' style='color:red;font-size:11px'>{{ nota
                                    }}</span>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Correos</span>
                                <v-autocomplete outlined dense chips clearable deletable-chips :items="correos.items"
                                    v-model="correos.valor" :search-input.sync="correos.searchIteam"
                                    no-data-text="Introduzca un correo válido" @keyup="addMailValider('correo')"
                                    @change="resetItemsSelector('correo')" :error="errorCorreo"
                                    :error-messages="msgerrorCorreo"></v-autocomplete>
                                <v-chip class="ma-2" close color="#536DFE" dark
                                    v-for="(chips, chipIndex) in correos.selectedItems" :key="chipIndex"
                                    @click:close="deleteFromList('correo', chips)">
                                    {{ chips }}
                                </v-chip>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="ma-2" color="primary" title="Enviar" @click="AceptarUI()" :disabled="btndisabled"
                            v-if="!BotonReactivar">
                            Guardar
                        </v-btn>
                        <v-btn class="ma-2" color="primary" title="Enviar" @click="ReactivarUsuario()"
                            :disabled="btndisabled" v-else>
                            Reactivar
                        </v-btn>
                        <v-btn class="ma-2" v-on:click="limpiar(1)" color="default" :disabled="btndisabled">
                            Limpiar
                        </v-btn>
                        <v-btn color="error" class="ma-2" v-on:click="regresar()" :disabled="btndisabled">
                            Cancelar
                        </v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
                <v-card flat class="text-xs-center ma-3" v-else>
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Alta Usuario Externo</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span>Tipo de Usuario: </span>
                                <v-select dense outlined placeholder="Seleccione tipo de usuario" :items="tipoUsr"
                                    item-text="label" item-value="tipo" v-model="alta.tipoUsr">
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8" style="display: grid; place-items: center;">
                                <span style="font-weight: bold; font-size: x-large; text-align: center;"
                                    class="ml-1">Datos del
                                    Cliente</span>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Cliente</span>
                                <v-select dense outlined placeholder="Seleccione un cliente" :items="clientes"
                                    item-text="Nombre" item-value="Clave" v-model="alta.cliente" :error="errorCliente"
                                    :error-messages="msgerrorCliente" @change="GenerarLoginCliente()"></v-select>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Flotilla</span>
                                <v-select dense outlined placeholder="Seleccione una flotilla" :disabled="disflotilla"
                                    :filled="disflotilla" :items="flotillas" item-text="Nombre" item-value="Clave"
                                    v-model="alta.flotilla"></v-select>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Número de Agente</span>
                                <v-combobox v-model="alta.agente" :disabled="disagente" :filled="disagente"
                                    @update:search-input="ObtenerAgentes"
                                    :hint="'Escribe al menos un carácter (letra o número) para buscar'"
                                    :items="agentes?.map(a => a.Clave + ' | ' + a.Nombre)" outlined dense>
                                </v-combobox>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center" v-if="pauobs != ''">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Observaciones: </span>
                                <br />
                                <span class="ml-1" style="font-size: large; font-weight: bold;">{{ pauobs }} </span>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8" style="display: grid; place-items: center;">
                                <span style="font-weight: bold; font-size: x-large; text-align: center;"
                                    class="ml-1">Datos del
                                    Usuario</span>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>

                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Nombre(s)</span>
                                <v-text-field ref="nombreField" outlined dense v-model="alta.nombre"
                                    class="text-uppercase" v-on:blur="GenerarLoginCliente()" :error="errorNombre"
                                    :error-messages="msgerrorNombre" @keypress="validarRegex($event, 'LE');"
                                    maxlength="20" @input="updateCampo('nombre', $event)">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Apellido Paterno</span>
                                <v-text-field ref="apellidoPField" v-model="alta.apellidoP" outlined dense
                                    v-on:blur="GenerarLoginCliente()" :error="errorApellidoP"
                                    :error-messages="msgerrorApellidoP" @keypress="validarRegex($event, 'LEA')"
                                    maxlength="20" @input="updateCampo('apellidoP', $event)"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Apellido Materno</span>
                                <v-text-field ref="apellidoMField" v-model="alta.apellidoM" outlined dense
                                    v-on:blur="GenerarLoginCliente()" @keypress="validarRegex($event, 'LEA')"
                                    maxlength="20" @input="updateCampo('apellidoM', $event)"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8" style="display: grid; place-items: center;">
                                <span style="font-weight: bold; font-size: x-large; text-align: center;"
                                    class="ml-1">Login del
                                    Usuario</span>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Login</span>
                                <multiselect v-model="alta.login" @input="validaProveedor = false" id="ajax"
                                    open-direction="bottom" :options="logins" :searchable="true" :options-limit="30"
                                    :taggable="true" deselect-label="No se puede remover el valor seleccionado"
                                    placeholder="Seleccione una opción" :disabled="disabledLogin" @tag="addLogin"
                                    tag-position="bottom" tag-placeholder="Agregar como nueva etiqueta"
                                    @select="errorLogin = false" selectLabel="Seleccionar" selected-label="Seleccionado"
                                    :allow-empty="false">
                                    <template slot="clear" slot-scope="props">
                                        <div class="multiselect__clear" v-if="alta.login"
                                            @mousedown.prevent.stop="limpiarLogin(props.search)"></div>
                                    </template>
                                    <span slot="noResult">No hay resultados.</span>
                                </multiselect>
                                <span v-if="errorLogin" class='spanError' style='color:red;font-size:11px'>{{
                                    msgerrorLogin }}</span>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" md="8">
                                <span class="ml-1">Correos</span>
                                <v-autocomplete chips clearable deletable-chips :items="correos.items"
                                    v-model="correos.valor" :search-input.sync="correos.searchIteam"
                                    no-data-text="Introduzca un correo válido" @keyup="addMailValider('correo')"
                                    @change="resetItemsSelector('correo')" :error="errorCorreo"
                                    :error-messages="msgerrorCorreo" outlined dense></v-autocomplete>
                                <v-chip class="ma-2" close color="#536DFE" dark
                                    v-for="(chips, chipIndex) in correos.selectedItems" :key="chipIndex"
                                    @click:close="deleteFromList('correo', chips)">
                                    {{ chips }}
                                </v-chip>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="ma-2" color="primary" title="Enviar" @click="AceptarUE()" :disabled="btndisabled">
                            Guardar
                        </v-btn>
                        <v-btn class="ma-2" v-on:click="limpiar(2)" color="default" :disabled="btndisabled">
                            Limpiar
                        </v-btn>
                        <v-btn color="error" class="ma-2" v-on:click="regresar()" :disabled="btndisabled">
                            Cancelar
                        </v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import DataTable from "@/components/pages/DataTableNet/DataTable";
import Sistemas from "@/services/Sistemas/sistemas.service.js";
import Menu from '@/components/pages/Sistemas/MenuSistemas.vue';
import PreAlta from "@/services/PreAlta/preAlta.service.js";

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable,
        Menu,
    },
    data() {
        return {
            showcargando: true,
            valtipoUsr: 1,
            tipoUsr: [
                { label: "Usuario Interno (AUSA)", tipo: 1 },
                { label: "Usuario Externo (Cliente)", tipo: 2 },
            ],
            perfiles: [],
            areas: [],
            puestos: [],
            estados: [],
            localidades: [],
            gerencias: [],
            supervisorias: [],
            tiposEjecutivo: [],
            clientes: [],
            logins: [],
            flotillas: [],
            agentes: [],
            abogados: [],
            jefesArea: [],
            alta: {
                tipoUsr: 1,
                perfil: '',
                valpermisosdef: true,
                area: '',
                puesto: '',
                pfvalor: '',
                jefe: '',
                esquema: null,
                nombre: '',
                apellidoP: '',
                apellidoM: '',
                fechaNac: '',
                rfc: '',
                gerencia: '',
                supervisoria: '',
                tipoEjec: '',
                cliente: '',
                estado: '',
                localidad: '',
                login: '',
                flotilla: '',
                agente: '',
                prclave: ''
            },
            modal: false,
            showprclave: false,
            showtipoEjec: false,
            showCuentas: false,
            showGerencia: false,
            showSupervisorias: false,

            disabledPuesto: true,
            startdate: '',
            dateCurrent: '',
            validEstado: false,
            validLocalidad: false,
            dislocalidad: true,
            disabledLogin: true,
            valNombre: false,
            valApP: false,
            valApM: false,
            correos: {
                items: [],
                valor: null,
                searchIteam: "",
                selectedItems: []
            },
            disflotilla: true,
            disoficina: true,
            disagente: true,
            disableSupervisorias: true,

            errorPerfil: false,
            msgerrorPerfil: '',
            errorArea: false,
            msgerrorArea: '',
            errorPuesto: false,
            msgerrorPuesto: '',
            errorNombre: false,
            msgerrorNombre: '',
            errorApellidoP: false,
            msgerrorApellidoP: '',
            errorfechaNac: false,
            msgerrorfechaNac: '',
            errorRFC: false,
            msgerrorRFC: '',
            errorLogin: false,
            msgerrorLogin: '',
            errorPrclave: false,
            msgerrorPrclave: '',
            errorTEjecutivo: false,
            msgerrorTEjecutivo: '',
            errorClienteI: false,
            msgerrorClienteI: '',
            errorGerencia: false,
            msgerrorGerencia: '',
            errorSupervisorias: false,
            msgerrorSupervisorias: '',

            errorCliente: false,
            msgerrorCliente: '',
            errorCorreo: false,
            msgerrorCorreo: '',

            disabledJefe: true,
            errorJefe: false,
            msgerrorJefe: '',
            errorRadio: false,
            msgerrorRadio: '',

            btndisabled: false,
            pauid: null,
            pauobs: '',
            errorApellidoM: false,
            msgerrorApellidoM: '',
            sending: false,
            disabledtipousr: false,
            /////
            valCliente: false,
            pauautpend: false,
            ////
            reactivacion: false,
            nota: '',
            shownota: false,
            usloginReactivar: '',
            BotonReactivar: false
        }
    },
    computed: {
        ...mapState(['permission', 'domain']),
        ...mapGetters(['getUser', 'THEME_STATE']),

    },
    watch: {
        async 'alta.tipoUsr'(val) {
            this.valtipoUsr = val;
            if (val == 2) {
                await this.ObtenerClientes();
            }
            await this.limpiar(val);
        },
        async 'alta.perfil'(val) {
            if (val != '') {
                this.alta.pfvalor = '';
                this.errorPerfil = false;
                this.msgerrorPerfil = '';
                this.showprclave = false;
                this.showtipoEjec = false;
                this.showCuentas = false;
                this.showGerencia = false;
                this.showSupervisorias = false;

                this.alta.gerencia = '';
                this.alta.supervisoria = '';
                this.alta.tipoEjec = '';
                this.alta.cliente = '';

                this.errorCorreo = false;
                this.msgerrorCorreo = '';

                const perfilEncontrado = this.perfiles.find(p => p.pfclave === val);
                this.alta.pfvalor = perfilEncontrado.pfvalor;
                if (val == 4) { //Abogado
                    this.showprclave = true;
                } else if (val == 5 || val == 15) { //Ejecutivos
                    this.showtipoEjec = true;
                    this.showCuentas = true;
                    await this.ObtenerTiposEjecutivo();
                    await this.ObtenerClientes();
                } else if (val == 3) { //Gerente
                    this.showGerencia = true;
                    await this.ObtenerGerencias();
                } else if (val == 2) {  //Supervisor
                    this.showGerencia = true;
                    await this.ObtenerGerencias();
                    this.showSupervisorias = true;
                }
            }

        },
        async 'alta.puesto'(val) {
            if (val != '') {
                this.errorPuesto = false;
                this.msgerrorPuesto = '';
                this.alta.jefe = '';
                await this.ObtenerJefes(null, this.alta.area, val);
                this.disabledJefe = false;
            }
        },
        'alta.jefe'(val) {
            if (val != '') {
                this.errorJefe = false;
                this.msgerrorJefe = ''
            }
        },
        async 'alta.gerencia'(val) {
            if (val != '' && this.alta.perfil == 2) {
                await this.ObtenerSupervisorias(val)
                this.errorGerencia = false;
                this.msgerrorGerencia = '';
            } else if (val != '' && this.alta.gerencia == 1) {
                this.errorGerencia = false;
                this.msgerrorGerencia = '';
            }
        },
        async 'alta.area'(val) {
            if (val != '') {
                this.errorArea = false;
                this.msgerrorArea = ''
                this.alta.jefe = '';
                await this.ObtenerPuestos(val);
                this.disabledPuesto = false;

            }
        },
        'alta.nombre'(val) {
            if (val != '') {
                if (val.trim().length < 3) {
                    this.errorNombre = true;
                    this.msgerrorNombre = 'El campo nombre debe de tener minimo 3 caracteres'
                } else {
                    this.errorNombre = false;
                    this.msgerrorNombre = ''
                }
            }
        },
        'alta.apellidoP'(val) {
            if (val != '') {
                if (val.trim().length < 3) {
                    this.errorApellidoP = true;
                    this.msgerrorApellidoP = 'El campo apellido paterno debe de tener minimo 3 caracteres'
                } else {
                    this.errorApellidoP = false;
                    this.msgerrorApellidoP = ''
                }
            }
        },
        'alta.apellidoM'(val) {
            if (val != '') {
                if (val.trim().length < 3) {
                    this.errorApellidoM = true;
                    this.msgerrorApellidoM = 'El campo apellido materno debe de tener minimo 3 caracteres'
                } else {
                    this.errorApellidoM = false;
                    this.msgerrorApellidoM = ''
                }
            }
        },
        async 'alta.cliente'(val) {
            if (val != '' && this.alta.tipoUsr == 2) {
                this.errorCliente = false;
                this.msgerrorCliente = ''
                await this.ObtenerFlotillas();
                this.disagente = false;
            } else if (val != '' && this.alta.tipoUsr == 1) {
                this.errorClienteI = false;
                this.msgerrorClienteI = ''
            }
        },
        'alta.fechaNac'(val) {
            if (val != '') {
                this.errorfechaNac = false;
                this.msgerrorfechaNac = ''
            }
        },
        'alta.login'(val) {
            if (val != '') {
                this.errorLogin = false;
                this.msgerrorLogin = '';
                this.nota = "";
                this.shownota = false;

                if (this.reactivacion && this.usloginReactivar != "") {
                    if (val != this.usloginReactivar) {
                        this.BotonReactivar = false
                    } else {
                        this.BotonReactivar = true

                    }
                }
            }
        },
        'alta.tipoEjec'(val) {
            if (val != '') {
                this.errorTEjecutivo = false;
                this.msgerrorTEjecutivo = '';
            }
        },
        'alta.supervisoria'(val) {
            if (val != '') {
                this.errorSupervisorias = false;
                this.msgerrorSupervisorias = '';
            }
        },
        'alta.esquema'(val) {
            if (val != null) {
                this.errorRadio = false;
                this.msgerrorRadio = '';
            }
        }
    },
    methods: {
        async updateCampo(campo, newValue) {
            const input = this.$refs[campo + 'Field'].$el.querySelector('input');
            if (!input) {

                return;
            }
            const selectionStart = input.selectionStart;
            const selectionEnd = input.selectionEnd;
            this.alta[campo] = newValue.toUpperCase();
            // Restaurar la posición del cursor
            this.$nextTick(() => {
                input.setSelectionRange(selectionStart, selectionEnd);
            });

            if (campo == 'rfc') {
                await this.validarRFC(this.alta.rfc)
            }
        },
        regresar() {
            this.$router.push({ name: 'BusquedaUsuarios' }).catch((error) => error);
        },
        async ObtenerPerfiles() {
            this.perfiles = await Sistemas.ObtenerPerfilesAdministracion();
        },
        async ObtenerAreas() {
            this.areas = await Sistemas.ObtenerAreas();
        },
        async ObtenerPuestos(val) {
            this.puestos = await Sistemas.ObtenerPuestos(val);
        },
        async ObtenerJefes(usuario, area, puesto) {
            this.jefesArea = await Sistemas.ObtenerJefes(usuario, area, puesto)
        },
        async ObtenerEstados() {
            this.estados = await Sistemas.ObtenerEstados();
        },
        async ObtenerLocalidad(esclave) {
            this.dislocalidad = false;
            this.alta.localidad = '';
            this.localidades = await Sistemas.ObtenerLocalidades(esclave.Clave);
        },
        async ObtenerGerencias() {
            this.gerencias = await Sistemas.ObtenerGerencias();
        },
        async ObtenerSupervisorias(geclave) {
            this.supervisorias = await Sistemas.ObtenerSupervisorias(geclave);
            this.disableSupervisorias = false;
        },
        async ObtenerTiposEjecutivo() {
            this.tiposEjecutivo = await Sistemas.ObtenerTiposEjecutivo();
        },
        async ObtenerClientes() {
            this.clientes = await Sistemas.ObtenerClientes();
        },
        async limpiar(tipo) {
            this.showcargando = true;
            this.alta = {
                tipoUsr: tipo,
                perfil: '',
                valpermisosdef: true,
                area: '',
                puesto: '',
                pfvalor: '',
                jefe: '',
                esquema: null,
                nombre: '',
                apellidoP: '',
                apellidoM: '',
                fechaNac: '',
                rfc: '',
                gerencia: '',
                supervisoria: '',
                tipoEjec: '',
                cliente: '',
                estado: '',
                localidad: '',
                login: '',
                flotilla: '',
                agente: '',
                prclave: ''
            };
            this.logins = [];
            this.correos = {
                items: [],
                valor: null,
                searchIteam: "",
                selectedItems: []
            };
            this.nota = "";
            this.shownota = false;
            this.errorPerfil = false;
            this.msgerrorPerfil = '';
            this.errorArea = false;
            this.msgerrorArea = '';
            this.errorPuesto = false;
            this.msgerrorPuesto = '';
            this.errorNombre = false;
            this.msgerrorNombre = '';
            this.errorApellidoP = false;
            this.msgerrorApellidoP = '';
            this.errorApellidoM = false;
            this.msgerrorApellidoM = '';
            this.errorfechaNac = false;
            this.msgerrorfechaNac = '';
            this.errorRFC = false;
            this.msgerrorRFC = '';
            this.errorLogin = false;
            this.msgerrorLogin = '';
            this.errorPrclave = false;
            this.msgerrorPrclave = '';
            this.errorTEjecutivo = false;
            this.msgerrorTEjecutivo = '';
            this.errorClienteI = false;
            this.msgerrorClienteI = '';
            this.errorGerencia = false;
            this.msgerrorGerencia = '';
            this.errorSupervisorias = false;
            this.msgerrorSupervisorias = '';

            this.errorCliente = false;
            this.msgerrorCliente = '';
            this.errorCorreo = false;
            this.msgerrorCorreo = '';

            this.disabledJefe = true;
            this.errorJefe = false;
            this.msgerrorJefe = '';
            this.errorRadio = false;
            this.msgerrorRadio = '';
            this.btndisabled = false;
            this.disabledLogin = true;

            this.disabledPuesto = true;

            this.showprclave = false;
            this.showtipoEjec = false;
            this.showCuentas = false;
            this.showGerencia = false;
            this.showSupervisorias = false;

            if (this.pauid != null) {
                let response = await PreAlta.DetalleSolicitud(this.pauid);
                this.alta.tipoUsr = tipo;
                this.disabledtipousr = true;
                this.alta.nombre = response.paunombre;
                this.alta.apellidoP = response.pauapellidoP;
                this.alta.apellidoM = response.pauapellidoM;
                this.alta.rfc = response.pauRFC;
                this.alta.area = response.Direccion;
                this.alta.puesto = response.puid;
                this.alta.estado = { Clave: response.esclave, Nombre: response.esnombre }
                await this.ObtenerLocalidad(this.alta.estado.Clave);
                this.alta.localidad = { Clave: response.loclave, Nombre: response.lonombre }
                this.alta.fechaNac = response.paufechaNacAlta;
                this.correos.selectedItems.push(response.paucorreo);
                this.pauobs = response.pauobs;
                this.reactivacion = response.paureactivacion;
                this.BotonReactivar = this.reactivacion;

                await this.GenerarLogin();
                this.disabledLogin = false;
                this.dislocalidad = false;
                this.disabledPuesto = false;
                this.disabledJefe = false;
                this.alta.jefe = response.usIdJefe != 0 ? response.usIdJefe : '';
                this.alta.esquema = response.pauesquema != '' ? response.pauesquema : null;
                this.pauautpend = response.pauautpend;
            }
            this.showcargando = false;
        },
        async GenerarLogin() {

            this.alta.nombre = this.alta.nombre.trim().length > 0 ? this.alta.nombre.trim() : '';
            this.valNombre = this.alta.nombre.trim().length > 1 ? true : false;

            this.valApP = this.alta.apellidoP.trim().length > 1 ? true : false;
            this.alta.apellidoP = this.alta.apellidoP.trim().length > 0 ? this.alta.apellidoP.trim() : '';

            this.valApM = this.alta.apellidoM.trim().length > 1 ? true : false;
            this.alta.apellidoM = this.alta.apellidoM.trim().length > 0 ? this.alta.apellidoM.trim() : '';

            if (this.valNombre && this.valApP) {
                this.alta.login = '';
                let response = await Sistemas.GenerarLogin(this.alta.nombre, this.alta.apellidoP, this.alta.apellidoM, this.reactivacion);
                this.logins = response.opcionesUslogin;
                if (this.reactivacion) {
                    this.nota = response.encontrado ? 'Se encotro el siguiente usuario en sistema dado de alta e inactivo' : 'No se encontro ningun usuario inactivo con esta información'
                    this.shownota = true;
                    if (response.encontrado) {
                        this.usloginReactivar = response.opcionesUslogin[0];
                    } else {
                        this.BotonReactivar = false;
                    }

                }
                this.disabledLogin = false;
            } else {
                this.disabledLogin = true;
            }
        },
        async GenerarLoginCliente() {
            this.alta.nombre = this.alta.nombre.trim().length > 0 ? this.alta.nombre.trim() : '';
            this.valNombre = this.alta.nombre.trim().length > 1 ? true : false;

            this.valApP = this.alta.apellidoP.trim().length > 1 ? true : false;
            this.alta.apellidoP = this.alta.apellidoP.trim().length > 0 ? this.alta.apellidoP.trim() : '';

            this.valApM = this.alta.apellidoM.trim().length > 1 ? true : false;
            this.alta.apellidoM = this.alta.apellidoM.trim().length > 0 ? this.alta.apellidoM.trim() : '';

            this.alta.cliente = this.alta.cliente.trim().length > 0 ? this.alta.cliente.trim() : '';

            this.valCliente = this.alta.cliente.trim().length > 0 ? true : false;

            if (this.valNombre && this.valApP && this.valCliente) {
                this.alta.login = '';
                this.logins = await Sistemas.GenerarLoginCliente(this.alta.nombre, this.alta.apellidoP, this.alta.apellidoM, this.alta.cliente);
                this.disabledLogin = false;
            } else {
                this.disabledLogin = true;
            }

        },
        addMailValider(tipo) {
            var regex = /^([\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})(;[\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})*$/;
            if (tipo == 'correo') {
                if (regex.test(this.correos.searchIteam)) {
                    this.correos.items = [
                        {
                            value: this.correos.searchIteam,
                            text: this.correos.searchIteam,
                        },
                    ];
                }
            }
        },
        deleteFromList(tipo, item) {
            if (tipo == 'correo') {
                this.correos.selectedItems = this.correos.selectedItems.filter((element) => element !== item);
                if (this.correos.selectedItems.length == 0) {
                    this.correos.valor = null;
                }
            }
        },
        resetItemsSelector(tipo) {
            if (tipo == 'correo') {
                if (this.correos.valor != null) {
                    this.errorCorreo = false
                    this.msgerrorCorreo = '';
                    this.mailSelected++;
                    this.correos.selectedItems.push(this.correos.valor);
                    this.correos.searchIteam = null;
                    this.correos.items = null;
                }
            }
        },
        async ObtenerFlotillas() {
            this.flotillas = await Sistemas.ObtenerFlotillas(this.alta.cliente);
            this.disflotilla = this.flotillas.length > 0 ? false : true;
        },
        async ObtenerAgentes(busqueda) {
            if (!busqueda) {
                this.agentes = []
                return;
            }
            this.agentes = await Sistemas.ObtenerAgentes(this.alta.cliente, busqueda);
        },
        async BuscarAbogados(busqueda) {
            if (!busqueda) return;
            if (busqueda?.length < 3) {
                this.abogados = []
                return;
            }
            this.abogados = await Sistemas.ObtenerAbogados(busqueda);
        },
        async AceptarUI() {
            let val = await this.Validar(1);
            if (val == 0) {
                this.btndisabled = true;
                if (this.sending) { // Verifica si ya se está enviando
                    return; // Si es así, no hace nada
                }
                this.sending = true; // Establece la variable de control en true
                this.$swal({
                    title: 'Guardando usuario, espere, por favor.',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        let usvalor = null, tipoEjecutivo = null, cuentas = [];
                        if (this.alta.perfil == 4) { //4	Abogado Operativo	23
                            usvalor = this.alta.prclave.prclave;
                        } else if (this.alta.perfil == 3) { //3	Gerente Operativo	25
                            usvalor = this.alta.gerencia
                        } else if (this.alta.perfil == 2) {  //2	Supervisor Operativo	24
                            usvalor = this.alta.supervisoria
                        } else if (this.alta.perfil == 15 || this.alta.perfil == 5) { //15	Ejecutivo Dictamen	27
                            tipoEjecutivo = this.alta.tipoEjec;
                            cuentas = this.alta.cliente
                        }
                        let puestofind = this.puestos.find(p => p.puid === this.alta.puesto);
                        let puestoDesc = puestofind.DescripcionPuesto;

                        let accionPerfil = this.alta.valpermisosdef == true ? 1 : 4;
                        let localidad = this.alta.localidad != '' ? this.alta.localidad.Clave : null;
                        let response = await Sistemas.InsertarInterno(this.alta.login, this.alta.perfil, this.alta.pfvalor,
                            usvalor, accionPerfil, tipoEjecutivo, cuentas, this.alta.puesto,
                            this.alta.nombre, this.alta.apellidoP, this.alta.apellidoM, this.alta.fechaNac, this.alta.rfc,
                            this.correos.selectedItems.join(';'), localidad, this.alta.esquema, this.alta.jefe, this.pauid, puestoDesc,
                            this.pauautpend)
                        if (response) {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Usuario creado exitosamente.',
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                let usuario = {
                                    Login: this.alta.login
                                };
                                await MetodosGenerales.guardarEnSesionInfoReporte(usuario, 'DetalleUsuarioBusqueda');
                                this.$router.replace({ name: 'DetalleUsuario' }).catch(error => error);
                            });
                        } else {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Error',
                                text: 'Ocurrió un error al generar el usuario, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                this.btndisabled = false;
                            });
                        }
                    }
                })
                // Al final del proceso, restablece las variables de control
                this.sending = false;
            }

        },
        async AceptarUE() {
            let val = await this.Validar(2);
            if (val == 0) {
                this.btndisabled = true;
                if (this.sending) { // Verifica si ya se está enviando
                    return; // Si es así, no hace nada
                }
                this.sending = true; // Establece la variable de control en true
                this.$swal({
                    title: 'Guardando usuario, espere, por favor.',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        let response = await Sistemas.InsertarExterno(this.alta.login, this.alta.cliente,
                            this.alta.flotilla, this.alta.agente, this.alta.nombre, this.alta.apellidoP, this.alta.apellidoM,
                            this.correos.selectedItems.join(';'), this.pauid)
                        if (response) {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Usuario creado exitosamente.',
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                let usuario = {
                                    Login: this.alta.login
                                };
                                await MetodosGenerales.guardarEnSesionInfoReporte(usuario, 'DetalleUsuarioBusqueda');
                                this.$router.replace({ name: 'DetalleUsuario' }).catch(error => error);
                            });
                        } else {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Error',
                                text: 'Ocurrió un error al generar el usuario, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                this.btndisabled = false;
                            });
                        }
                    }
                })
                // Al final del proceso, restablece las variables de control
                this.sending = false;
            }
        },
        async Validar(tipo) {
            let validacion = 0;
            if (tipo == 1) {
                //perfil
                if (this.alta.perfil == '') {
                    this.errorPerfil = true;
                    this.msgerrorPerfil = 'campo requerido'
                    validacion++;
                }
                //Abogado
                if (this.alta.perfil == 4 && this.alta.prclave == '') {
                    this.errorPrclave = true;
                    this.msgerrorPrclave = 'campo requerido';
                    validacion++;

                }
                //Ejecutivo y Ejecutivo Operativo
                if ((this.alta.perfil == 5 || this.alta.perfil == 15) && this.alta.tipoEjec == '') {
                    this.errorTEjecutivo = true;
                    this.msgerrorTEjecutivo = 'campo requerido';
                    validacion++;

                }
                //Para todos
                if (this.correos.selectedItems.length == '') {
                    this.errorCorreo = true;
                    this.msgerrorCorreo = 'campo requerido';
                    validacion++;
                }
                //Ejecutivo y Ejecutivo Operativo
                if ((this.alta.perfil == 5 || this.alta.perfil == 15) && this.alta.cliente == '') {
                    this.errorClienteI = true;
                    this.msgerrorClienteI = 'campo requerido'
                    validacion++;

                }
                //Gerente operativo
                if ((this.alta.perfil == 3 || this.alta.perfil == 2) && this.alta.gerencia == '') {
                    this.errorGerencia = true;
                    this.msgerrorGerencia = 'campo requerido';
                    validacion++;

                }
                if (this.alta.perfil == 2 && this.alta.supervisoria == '') {
                    this.errorSupervisorias = true;
                    this.msgerrorSupervisorias = 'campo requerido';
                    validacion++;

                }
                //area
                if (this.alta.area == '') {
                    this.errorArea = true;
                    this.msgerrorArea = 'campo requerido';
                    validacion++;

                }
                //puesto
                if (this.alta.puesto == '') {
                    this.errorPuesto = true;
                    this.msgerrorPuesto = 'campo requerido';
                    validacion++;

                }
                //Jefe directo
                if (this.alta.jefe == '') {
                    this.errorJefe = true;
                    this.msgerrorJefe = 'campo requerido';
                    validacion++;

                }
                //Esquema
                if (this.alta.esquema == null) {
                    this.errorRadio = true;
                    this.msgerrorRadio = 'campo requerido';
                    validacion++;

                }
                //nombre
                if (this.alta.nombre == '') {
                    this.errorNombre = true;
                    this.msgerrorNombre = 'campo requerido';
                    validacion++;
                } else if (this.alta.nombre.trim().length < 3) {
                    this.errorNombre = true;
                    this.msgerrorNombre = 'El campo nombre debe de tener minimo 3 caracteres';
                    validacion++;
                }

                //apellido paterno
                if (this.alta.apellidoP == '') {
                    this.errorApellidoP = true;
                    this.msgerrorApellidoP = 'campo requerido';
                    validacion++;
                } else if (this.alta.apellidoP.trim().length < 3) {
                    this.errorApellidoP = true;
                    this.msgerrorApellidoP = 'El campo apellido paterno debe de tener minimo 3 caracteres';
                    validacion++;
                }

                if (this.alta.apellidoM != '') {
                    if (this.alta.apellidoM.trim().length == 1 || this.alta.apellidoM.trim().length < 3) {
                        this.errorApellidoM = true;
                        this.msgerrorApellidoM = 'El campo apellido materno debe de tener minimo 3 caracteres';
                        validacion++;
                    }

                }

                //fecha de nacimiento
                if (this.alta.fechaNac == '') {
                    this.errorfechaNac = true;
                    this.msgerrorfechaNac = 'campo requerido';
                    validacion++;

                }
                //RFC
                if (this.alta.rfc == '') {
                    this.errorRFC = true;
                    this.msgerrorRFC = 'campo requerido';
                    validacion++;

                }
                //login
                if (this.alta.login == '') {
                    this.errorLogin = true;
                    this.msgerrorLogin = 'campo requerido';
                    validacion++;
                }

                if (this.alta.estado != '' && this.alta.localidad == '') {
                    this.validLocalidad = true;
                    validacion++;
                }
            } else if (tipo == 2) {
                //Cliente
                if (this.alta.cliente == '') {
                    this.errorCliente = true;
                    this.msgerrorCliente = 'campo requerido';
                    validacion++;

                }
                //nombre
                if (this.alta.nombre == '') {
                    this.errorNombre = true;
                    this.msgerrorNombre = 'campo requerido';
                    validacion++;

                }
                //apellido paterno
                if (this.alta.apellidoP == '') {
                    this.errorApellidoP = true;
                    this.msgerrorApellidoP = 'campo requerido';
                    validacion++;

                }
                //login
                if (this.alta.login == '') {
                    this.errorLogin = true;
                    this.msgerrorLogin = 'campo requerido';
                    validacion++;

                }
                //Correos
                if (this.correos.selectedItems.length == 0) {
                    this.errorCorreo = true;
                    this.msgerrorCorreo = 'campo requerido';
                    validacion++;

                }

            }
            return validacion
        },
        validarRegex(evt, tipo) {
            return MetodosGenerales.validarRegex(evt, tipo);
        },
        validarRFC(dato) {
            var pattern = /^([A-Z&Ññ]{3,4})\d{6}$/i;
            if (pattern.test(dato)) {
                this.errorRFC = false;
                this.msgerrorRFC = "";
            } else {
                this.errorRFC = true;
                this.msgerrorRFC = "RFC inválido.";
            }
        },
        limpiarProveedor() {
            this.alta.abogado = '';
            this.abogados = [];
        },
        limpiarLogin() {
            this.alta.login = '';
            this.logins = [];
        },
        async addLogin(newLogin) {
            newLogin = newLogin.trim()

            if (newLogin.length > 16) {
                this.alta.login = '';
                this.errorLogin = true;
                this.msgerrorLogin = 'El login no puede tener más de 16 caracteres.';
            } else if (!/^[a-zA-Z0-9]*$/.test(newLogin) && this.alta.tipoUsr == 1) {
                this.alta.login = '';
                this.errorLogin = true;
                this.msgerrorLogin = 'Solo se permiten letras y números.';
            } else {

                let response = await Sistemas.VerificarUslogin(newLogin);
                if (response) {
                    this.errorLogin = true;
                    this.msgerrorLogin = 'El nombre de usuario ' + newLogin + ' ya esta en uso';
                    this.alta.login = '';
                } else {
                    this.errorLogin = false;
                    this.msgerrorLogin = '';
                    if (newLogin && !this.logins.includes(newLogin)) {
                        this.logins.push(newLogin);
                        this.alta.login = newLogin;
                    }
                }
            }
        },
        async ReactivarUsuario() {
            let val = await this.Validar(1);
            if (val == 0) {
                this.btndisabled = true;
                if (this.sending) { // Verifica si ya se está enviando
                    return; // Si es así, no hace nada
                }
                this.sending = true; // Establece la variable de control en true
                this.$swal({
                    title: 'Reactivando usuario, espere, por favor.',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        let usvalor = null, tipoEjecutivo = null, cuentas = [];
                        if (this.alta.perfil == 4) { //4	Abogado Operativo	23
                            usvalor = this.alta.prclave.prclave;
                        } else if (this.alta.perfil == 3) { //3	Gerente Operativo	25
                            usvalor = this.alta.gerencia
                        } else if (this.alta.perfil == 2) {  //2	Supervisor Operativo	24
                            usvalor = this.alta.supervisoria
                        } else if (this.alta.perfil == 15 || this.alta.perfil == 5) { //15	Ejecutivo Dictamen	27
                            tipoEjecutivo = this.alta.tipoEjec;
                            cuentas = this.alta.cliente
                        }
                        let puestofind = this.puestos.find(p => p.puid === this.alta.puesto);
                        let puestoDesc = puestofind.DescripcionPuesto;

                        let accionPerfil = this.alta.valpermisosdef == true ? 1 : 4;
                        let localidad = this.alta.localidad != '' ? this.alta.localidad.Clave : null;
                        let response = await Sistemas.ReactivarUsuarioPrealta(this.alta.login, this.alta.perfil, this.alta.pfvalor,
                            usvalor, accionPerfil, tipoEjecutivo, cuentas, this.alta.puesto,
                            this.alta.nombre, this.alta.apellidoP, this.alta.apellidoM, this.alta.fechaNac, this.alta.rfc,
                            this.correos.selectedItems.join(';'), localidad, this.alta.esquema, this.alta.jefe, this.pauid, puestoDesc,
                            this.pauautpend)

                        if (response) {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Usuario reactivado exitosamente.',
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                let usuario = {
                                    Login: this.alta.login
                                };
                                await MetodosGenerales.guardarEnSesionInfoReporte(usuario, 'DetalleUsuarioBusqueda');
                                this.$router.replace({ name: 'DetalleUsuario' }).catch(error => error);
                            });
                        } else {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Error',
                                text: 'Ocurrió un error al reactivar el usuario, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                this.btndisabled = false;
                            });
                        }
                    }
                })
                // Al final del proceso, restablece las variables de control
                this.sending = false;
            }
        },
    },
    async mounted() {
        let data = await MetodosGenerales.obtenerSessionReporte('AltaUsuario');

        this.startdate = moment().subtract(16, "y").format("YYYY[-]MM[-]DD");
        this.dateCurrent = moment().subtract(18, "y").format("YYYY[-]MM[-]DD");

        await this.ObtenerPerfiles();
        await this.ObtenerAreas();
        await this.ObtenerEstados();

        if (data != null) {
            this.pauid = data.pauid;
            let response = await PreAlta.DetalleSolicitud(this.pauid);
            this.alta.tipoUsr = 1;
            this.disabledtipousr = true;
            this.alta.nombre = response.paunombre;
            this.alta.apellidoP = response.pauapellidoP;
            this.alta.apellidoM = response.pauapellidoM;
            this.alta.rfc = response.pauRFC;
            this.alta.area = response.Direccion;
            this.alta.puesto = response.puid;
            this.alta.estado = { Clave: response.esclave, Nombre: response.esnombre }
            await this.ObtenerLocalidad(this.alta.estado.Clave);
            this.alta.localidad = { Clave: response.loclave, Nombre: response.lonombre }
            this.alta.fechaNac = response.paufechaNacAlta;
            this.correos.selectedItems.push(response.paucorreo);
            this.pauobs = response.pauobs;
            this.reactivacion = response.paureactivacion;
            this.BotonReactivar = this.reactivacion;
            await this.GenerarLogin();
            this.disabledLogin = false;
            this.dislocalidad = false;
            this.disabledPuesto = false;
            this.disabledJefe = false;
            this.alta.jefe = response.usIdJefe != 0 ? response.usIdJefe : '';
            this.alta.esquema = response.pauesquema != '' ? response.pauesquema : null;
            this.pauautpend = response.pauautpend;
        }
        this.showcargando = false;
    }
}
</script>
<style>
.text-uppercase {
    text-transform: uppercase;
}
</style>
